
import { create } from "zustand";

export const useMessages = create((set) => ({
  messages: [],

  initMessages: (initialMessage) => set({ 
    messages: [initialMessage] 
  }),

  addMessage: (newMessage) => set((state) => ({ 
    messages: [...state.messages, newMessage] 
  })),
}));